import { Dropdown } from "react-bootstrap";
import { formatDriverExpenseAmount } from "../utils/driver-expense.utils";

const DriverExpensesTable = ({ expenses, onEdit, onDelete, isDeleting }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Driver</th>
            <th>No. of Days</th>
            <th>Salary/Day</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {expenses.map((expense, index) => (
            <tr key={expense._id || `${expense.driverId?._id || "driver"}-${index}`}>
              <td>{index + 1}</td>
              <td>
                <div className="fw-semibold">{expense?.driverId?.name || "-"}</div>
                <small className="text-muted d-block">{expense?.driverId?.contactNumber || "-"}</small>
              </td>
              <td>{expense?.noOfDays ?? "-"}</td>
              <td>{formatDriverExpenseAmount(expense?.salaryPerDay)}</td>
              <td>{formatDriverExpenseAmount(expense?.totalAmount)}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(expense._id)} disabled={!expense._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(expense)}
                      className="text-danger"
                      disabled={!expense._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DriverExpensesTable;
